import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });
client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtParticipant(item) {
  return client.post("CourtParticipants/CreateCourtParticipant", prepareDataRequest(item));
}
function UpdateCourtParticipant(item) {
  return client.post("CourtParticipants/UpdateCourtParticipant", prepareDataRequest(item));
}
function DeleteCourtParticipant(id, uid) {
  return client.post("CourtParticipants/DeleteCourtParticipant", prepareDataRequest({ id, commandUserId: uid }));
}
function GetCourtParticipants(courtCaseId) {
  return client.post("CourtParticipants/GetCourtParticipants/", prepareRequest({ courtCaseId }));
}

export {
  CreateCourtParticipant,
  UpdateCourtParticipant,
  GetCourtParticipants,
  DeleteCourtParticipant,
}
